
import React, { useState } from 'react';
import './DemoBanner.css';
import BannerVideo from './BannerVideo.mp4'; // Import the video

const DemoBanner = () => {
  const [showVideo, setShowVideo] = useState(false);

  const handleWatchDemo = () => {
    setShowVideo(true);
  };

  const handleCloseVideo = () => {
    setShowVideo(false);
  };

  return (
    <div className="demo-banner">
      {!showVideo ? (
        <>
          <div className="demo-banner-content">
            <span className="play-icon">▶️</span>
            <span className="demo-text">Watch a Quick Demo on How to Solve Challenges</span>
          </div>
          <button className="watch-demo-button" onClick={handleWatchDemo}>
            WATCH DEMO
          </button>
        </>
      ) : (
        <div className="modal-overlay">
          <div className="video-modal">
            <button className="close-button-Demo" onClick={handleCloseVideo}>X</button>
            <div className="video-container">
              <video
                controls
                autoPlay
                width="100%"
                height="auto"
              >
                <source src={BannerVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DemoBanner;
